type StorageLike = {
	setItem: (key: string, value: string) => void;
	getItem: (key: string) => string | null;
	removeItem: (key: string) => void;
};

type AsyncStorageLike = {
	setItem: (key: string, value: string) => Promise<void>;
	getItem: (key: string) => Promise<string | null>;
	removeItem: (key: string) => Promise<void>;
};

const memoryStore: Record<string, string> = {};

const memoryStorage: StorageLike = {
	setItem: (key, value) => {
		memoryStore[key] = value;
	},
	getItem: key => (key in memoryStore ? memoryStore[key] : null),
	removeItem: key => {
		delete memoryStore[key];
	},
};

const browserStorage: StorageLike | null =
	typeof localStorage !== 'undefined'
		? {
				setItem: (key, value) => localStorage.setItem(key, value),
				getItem: key => localStorage.getItem(key),
				removeItem: key => localStorage.removeItem(key),
			}
		: null;

let nativeAsyncStorage: AsyncStorageLike | null = null;
if (!browserStorage) {
	try {
		nativeAsyncStorage = require('@react-native-async-storage/async-storage').default;
	} catch {
		nativeAsyncStorage = null;
	}
}

const storage: StorageLike = browserStorage ?? memoryStorage;

const LS = {
	set: (key: string, value: string) => {
		storage.setItem(key, value);
		if (nativeAsyncStorage) {
			nativeAsyncStorage.setItem(key, value).catch(() => {});
		}
	},
	get: (key: string) => storage.getItem(key),
	getAsync: async (key: string) => {
		const fromMemory = storage.getItem(key);
		if (fromMemory !== null || !nativeAsyncStorage) {
			return fromMemory;
		}

		const persisted = await nativeAsyncStorage.getItem(key);
		if (persisted !== null) {
			storage.setItem(key, persisted);
		}
		return persisted;
	},
	remove: (key: string) => {
		storage.removeItem(key);
		if (nativeAsyncStorage) {
			nativeAsyncStorage.removeItem(key).catch(() => {});
		}
	},
	getCasinoId: () => storage.getItem('casinoId'),
};

export default LS;
